import posthog from 'posthog-js';

posthog.init("8RPM7x_L30pPIXIT2C574MzG1py8W0Q9T-PrRvqMI8o", { api_host: 'https://app.posthog.com' });

export { posthog }